//fetch model from google cloud storage
export const fetchModel = (fileName) => {
    return `https://pakethorizons.ddns.net/api/files/serve-model?file=${fileName}`;
  };